import { Stack } from '@mui/material';
import StringLabel from './label';

type Props = {
  children: React.ReactNode;
};

export function OptionLabel({ children }: Props) {
  if (typeof children === 'string') {
    return <StringLabel>{children}</StringLabel>;
  }

  return (
    <Stack
      direction="row"
      gap="6px"
      alignItems="center"
      sx={{
        flex: '1 1 0',
        textAlign: 'left',
        color: 'var(--Gray-700, #344054)',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '24px',
      }}
    >
      {children}
    </Stack>
  );
}
